import React, { useState, useEffect, useRef } from 'react'
import { DownIcon } from '../Icons'

const Select = ({
  options,
  onSelect,
  width = 'w-96',
  placeholderValue,
  selected,
  labelValue,
  disabled,
  value,
}) => {
  const [open, setOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState(selected || '')
  const optionsRef = useRef(null)
  const inputRef = useRef(null)
  const [listPosition, setListPosition] = useState('bottom')
  const [highlightedIndex, setHighlightedIndex] = useState(-1)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open && !event.target.closest('.select-container')) {
        setOpen(false)
      }
    }

    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [open])

  // const toggle = () => {
  //   setOpen(open);
  // };

  const selectOption = (option) => {
    setSelectedOption(option)
    // setSelectedOption(option.label);
    setOpen(false)
    onSelect(option)
  }

  useEffect(() => {
    if (optionsRef.current) {
      const { bottom: inputBottom } = inputRef.current.getBoundingClientRect()
      const { height: optionsHeight } =
        optionsRef.current.getBoundingClientRect()
      const windowHeight = window.innerHeight

      if (windowHeight - inputBottom < optionsHeight) {
        setListPosition('top')
      } else {
        setListPosition('bottom')
      }
    }
  }, [open])

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && options?.length > 0) {
      setSelectedOption(options[highlightedIndex])
      onSelect(options[highlightedIndex])
      setOpen(false)
      inputRef.current.blur()
    } else if (event.key === 'ArrowDown') {
      event.preventDefault()
      setHighlightedIndex((prevIndex) =>
        prevIndex < options?.length - 1 ? prevIndex + 1 : prevIndex
      )
    } else if (event.key === 'ArrowUp') {
      event.preventDefault()
      setHighlightedIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : prevIndex
      )
    }
  }
  useEffect(() => {
    if (!selected) {
      setSelectedOption('')
    } else {
      setSelectedOption(selected)
    }
  }, [selected, value])
  return (
    <div
      className={`text-start  select-container relative w-full max-${width}`}
    >
      <label className="text-stone-700 text-xs md:text-base font-semibold ">
        {labelValue}
      </label>
      <button
        ref={inputRef}
        // onClick={toggle}
        onFocus={() => setOpen(true)}
        // onBlur={() => setOpen(false)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        // value={value}
        className={`text-start text-stone-500 text-xs  font-['Open Sans'] md:text-base flex w-full items-center justify-between pb-1 pt-2 bg-white   ${
          open ? 'border-b border-blue-500 ' : 'border-b border-gray-200'
        }`}
      >
        <span className="text-stone-500 text-xs md:text-base font-['Open Sans']">
          {selectedOption === ''
            ? placeholderValue || 'Choose option'
            : selectedOption.label}
        </span>

        <div
          className={`ml-auto transform transition-transform md:text-base duration-300 cursor-pointer ${
            open ? 'rotate-180' : ''
          }`}
        >
          <DownIcon />
        </div>
      </button>

      {open && (
        <ul
          ref={optionsRef}
          className={`absolute z-50 w-full bg-white border md:text-base rounded-lg shadow-lg mt-1 max-h-60 overflow-y-auto ${
            !open ? 'hidden' : ''
          } ${listPosition === 'top' ? 'bottom-full z-50' : 'top-full'}`}
        >
          {options?.map((option, index) => (
            <li
              key={option?.value}
              className={`px-4 py-2 cursor-pointer hover:bg-gray-50 md:text-base text-[11px] font-bold text-stone-500 text-start ${
                index === highlightedIndex ? 'bg-blue-50' : ''
              }`}
              onClick={() => selectOption(option)}
            >
              {option?.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default Select
